export default __webpack_public_path__ + "531db4d08ea12dd65c097a84a6b76159.png";